import { withQueryString } from "@/lib/api/api-helpers";
import { baseApi } from "@/redux/api/base-api";
import { IHttpResponse } from "@/types/api-response";
import {
  IVisaCard,
  IVisaSearchCountry,
  IVisaSearchQueryArgs,
  IVisaTypeOption,
} from "../types/visa.types";

type CommonSearchParams = {
  name?: string;
  skip?: number;
  limit?: number;
};

export const visaSearchApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    searchVisaCountry: builder.query<
      IHttpResponse<IVisaSearchCountry[]>,
      CommonSearchParams
    >({
      query: (params) => ({
        url: withQueryString("/b2c/visa/country", params),
        method: "GET",
      }),
    }),
    searchVisaType: builder.query<
      IHttpResponse<IVisaTypeOption[]>,
      CommonSearchParams
    >({
      query: (params) => ({
        url: withQueryString("/b2c/visa/visa-type", params),
        method: "GET",
      }),
    }),
    searchVisa: builder.query<IHttpResponse<IVisaCard[]>, IVisaSearchQueryArgs>({
      query: (params) => ({
        url: withQueryString("/b2c/visa/", params),
        method: "GET",
      }),
      providesTags: ["VISA_SEARCH"],
      keepUnusedDataFor: 600,
    }),
  }),
});

export const {
  useSearchVisaCountryQuery,
  useSearchVisaTypeQuery,
  useSearchVisaQuery,
} = visaSearchApi;
